export const LIABILITY_CLAUSE_TEMPLATE =
  'The hirer acknowledges full responsibility and liability for all Penalty Charge Notices (PCNs), parking charges, fines, fees, costs, and any associated expenses incurred during the hire period, including any costs arising from enforcement action or late payment.';
